import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import {IntegrationConfigModal} from './IntegrationConfigModal';
import yesterIcon from '../assets/yester_icon_blue_green.png';

export const YesterConfigModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;

    return (
        <IntegrationConfigModal
            initialSettings={store.payload!.yesterConfig}
            titleLabel={store.label('company.yester-config.title')}
            apiKeyLabel={store.label('company.yester-config.api-key.label')}
            authKeyId="yester-auth-key"
            disconnectLabel={store.label('company.yester-config.disconnect')}
            disconnectConfirmLabel={store.label('company.yester-config.disconnect-confirm')}
            saveConfig={(config): void => store.saveYesterConfig(config)}
            revokeConfig={async (): Promise<void> => store.revokeYesterConfig()}
            logoSrc={yesterIcon}
            logoAlt="Yester"
        />
    );
});
